import React from 'react'
import { Col, Row, Icon } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'
import titleData from '../../assets/data/title.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Title = (props) => {
  const handleClick = (id,value,text) => {
    props.setSpouseTitle(value,text);
    if(id === 4) {
      props.history.push('/other-title')
    } else {
      props.history.goBack()
    }
  }


  return (
    <Layout title={'คำนำหน้า'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกคำนำหน้า</h4>
      <Row>
        {
          titleData.map(element => {
            if(element.id === 4) {
              return (
                <StyledCol key={element.id}>
                  <Row style={{marginBottom: '-.5rem'}}>
                    <Col span={22}>
                      <Text onClick={() => handleClick(element.id, element.value, element.th)}>{element.th}</Text>
                    </Col>
                    <Col span={2}>
                      <Icon style={{marginTop: '.4rem'}} type="right"/>
                    </Col>
                  </Row>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            } else {
              return (
                <StyledCol key={element.id}>
                  <Text onClick={() => handleClick(element.id, element.value, element.th)}>{element.th}</Text>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setSpouseTitle: actions.setSpouseTitle
}

const TitleWithConnect = connect(null, mapDispatchToProps)(Title)

export default TitleWithConnect
